import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDatabase = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.25 7c0 1.105-3.384 2.25-7.25 2.25S4.75 8.105 4.75 7 8.134 4.75 12 4.75 19.25 5.895 19.25 7M19.25 12c0 1.105-3.384 2.25-7.25 2.25S4.75 13.105 4.75 12"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.25 7v10c0 1.105-3.384 2.25-7.25 2.25S4.75 18.105 4.75 17V7"
    />
  </svg>
);
export default SvgDatabase;
